window.StoryComponent = class {

	photoStoryDelay = 10;

	constructor(element, config) {
		this.element = element;
		this.config = config;
		this.storyData = [];
		this.root = null;
		this.modal = null;
		this.current_story = null;
		this.current_item = null;
		this.template = null;

		this.init();
	}

	init() {
		$(this.element).on('click', '.listing-story:not(.listing-story-trigger)', (e) => {
			e.preventDefault();
			e.stopPropagation();

			this.root = $(e.target).closest('.section-listing');
			console.log('click');
			if ($(e.currentTarget).parent().attr('data-story_queue') == "0") {
				this.open($(e.currentTarget).closest('.story').index());
			}
		});
	}

	async open(index = 0) {
		await Library.load(['moment']);

		this.template = Twig.twig({
			data: document.getElementById('story-modal.tpl').innerHTML
		});

		$('body').addClass('no-overflow ');

		this.storyData = [];

		// Recorrer todas las historias y procesar la info.
		for (let e of this.root.children()) {
			let tmp = $(e).data();
			this.storyData.push(tmp);
		}

		this.modal = $(this.template.render({'storyList': this.storyData, session: NOW.session}));

		// Bindings..
		this.modal
			.on("animationend", this.nextStory)
			.on('click', '.story-next', this.nextStory)
			.on('click', '.story-prev', this.previousStory)
			.on("click", '.story-unmute', this.unmuteVideo)
			.on("click", '[role="close"]', this.close)
			.on('click', '[role="deleteStory"]', this.deleteStory);

		$('body').append(this.modal);

		this.showStory(index);
	}

	close = () =>   {
		$('body').removeClass('no-overflow ');
		this.modal.remove();
		this.current_story = null;
		this.current_item = null;
	}

	 deleteStory = async() =>  {
		try {
			const $story = this.current_story;
			let story_id = this.current_item[0].dataset.id;

			axios.delete(`/api/profile/story/${story_id}`);

			this.close();
			location.reload();

		} catch (error) {
			ErrorHandler.process(error);
		}
	}

	renderTimeline(target) {
		this.options.seen = this.getLocalData();
		let tplTimeline = $(timeline(this.options));
		tplTimeline.on('click', '.story', (e) => {
			e.preventDefault();
			e.stopPropagation();
			let index = $(this).index();
			this.open(index);
		});
		$(target).html(tplTimeline);
	}

	pauseStoryContent() {
		const $story = this.current_story;
		const index = $story.data('show');
		const media = $( $story.find('.story-content').children().get(index) );

		if (media.is('video')) {
			media[0].pause();
			media[0].currentTime = 0;

			const source = media.find('source');
			const tmp = source.attr('src');
			source.removeAttr('src');
			media[0].load();
			source.attr('data-src', tmp);
		}
	}

	unmuteVideo = () => {
		const $story = this.current_story;
		let index = $story.data('show');
		let media = $( $story.find('.story-content').children().get(index) );
		if (media.is('video')) {
			let video = media[0];
			video.muted = false;
			video.volume = 1.0;
			video.removeAttribute('muted');
			$story.find('.story-unmute').hide();
		}
	}

	showStory(index = 0, last = false) {
		let story = $(this.modal.find('.story').get(index));
		this.current_story = story;

		story.find('.story-content').children().removeClass('show');
		this.modal.find('.story-scroll').css('transform', 'translate3d(-' + (100 * index) + 'vw,0px,0px)');

		let item_index = last ? story.find('.story-content').children().length - 1 : 0;
		this.showItem(story, item_index);
	}

	showItem(story, item_index = 0) {
		story.data('show', item_index);
		this.modal.find('.story-progress').find('div').removeClass('active');
		let slide = $(story.find('.story-progress').find('div').get(item_index));

		story.find('.story-content').children().removeClass('show');
		let media = $(story.find('.story-content').children().get(item_index));
		this.current_item = media;

		story.find('.ago').html(moment(media.data('ago') + "Z").local().fromNow());

		slide.prevAll().addClass('done');
		slide.removeClass('done');
		slide.nextAll().removeClass('done');

		if (media.is('video')) {
			let video = media[0];
			let source = media.find('source');

			if (source.attr('data-src')) {
				source.attr('src', source.attr('data-src'));
				media[0].load();
			}

			slide.addClass('paused');
			if (video.hasAttribute("controls")) {
				video.removeAttribute("controls");
			}
			if (!UtilityHelper.isMobile()) {
				video.muted = false;
				video.volume = 1.0;
				video.removeAttribute('muted');
				story.find('.story-unmute').hide();
			} else {
				if (video.hasAttribute('muted')) {
					story.find('.story-unmute').show();
				} else {
					story.find('.story-unmute').hide();
				}
			}

			var setDuration = () => {
				if (video.duration) {
					slide.find('b').css('animation-duration', `${video.duration}s`);
					slide.addClass('active');
				}
			};

			setDuration();
			video.addEventListener("loadedmetadata", setDuration);

			video.onwaiting = () => {
				slide.addClass('paused');
			};
			video.onplaying = () => {
				slide.removeClass('paused');
			};
			video.currentTime = 0;
			video.play().catch(error => {
				if (error.name === 'NotAllowedError') {
					console.error('La reproducción automática fue bloqueada. Necesita interacción del usuario.');
				} else {
					console.error('Error al intentar reproducir el video:', error);
				}
			});

		} else {
			story.find('.story-unmute').hide();
			slide.find('b').css('animation-duration', `${this.photoStoryDelay}s`);
			slide.addClass('paused');
			slide.addClass('active');

			setTimeout(() => {
				slide.removeClass('paused');
			}, 300);
		}

		media.addClass('show');
	}

	nextStory = () => {
		const $story = this.current_story;
		const pos_story = $story.index();
		const pos_item = $story.data('show');

		this.pauseStoryContent();

		if (pos_item < this.getTotalItems($story) - 1) {
			this.showItem($story, pos_item + 1);
			return;
		}

		this.seenStory($story);

		if (pos_story < this.getTotalStories() - 1) {
			this.showStory(pos_story + 1);
			return;
		}

		this.close();
	}

	previousStory = () =>  {
		const $story = this.current_story;
		const pos_story = $story.index();
		const pos_item = $story.data('show');

		if (pos_item > 0) {
			this.pauseStoryContent();
			this.showItem($story, pos_item - 1);
			return;
		}

		if (pos_story > 0) {
			this.pauseStoryContent();
			this.showStory(pos_story - 1, true);
			return;
		}
	}

	getTotalStories() {
		return this.modal.find('.story').length;
	}

	getTotalItems(story) {
		return $(story).find('.story-content').children().length;
	}

	add(data) {
		this.options.stories[0].media.push(data);
	}

	getLocalData() {
		var keyName = 'stories_seen';
		return window.localStorage[keyName] ? JSON.parse(window.localStorage[keyName]) : {};
	}

	seenStory(story) {
		let story_id = story.data('story_id');
		let media_id = story.data('media_id');
		$('.stories-list').find(`[data-story_id="${story_id}"] .img`).addClass('seen');

		let seen = this.getLocalData();
		seen[story_id] = media_id;
		var keyName = 'stories_seen';
		window.localStorage[keyName] = JSON.stringify(seen);
	}
}